import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from 'public/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class AmbassadorsProfileService {

  constructor(private http: HttpClient) { }

  // --- Educational Qualification ---
  AddOrUpdateAmbassadorEducationalQualification(data: any) {
    return this.http.post(`${environment.apiUrl}/AmbassadorsProfile/AddOrUpdateAmbassadorEducationalQualification`, data);
  }

  DeleteAmbassadorEducationalQualification(id: any) {
    return this.http.delete(`${environment.apiUrl}/AmbassadorsProfile/DeleteAmbassadorEducationalQualification/${id}`);
  }

  GetAmbassadorEducationalQualification(params: any) {
    return this.http.get(`${environment.apiUrl}/AmbassadorsProfile/GetAmbassadorEducationalQualification`, { params });
  }

  // --- Work Experience ---
  AddOrUpdateAmbassadorWorkExperience(data: any) {
    return this.http.post(`${environment.apiUrl}/AmbassadorsProfile/AddOrUpdateAmbassadorWorkExperience`, data);
  }

  DeleteAmbassadorWorkExperience(id: any) {
    return this.http.delete(`${environment.apiUrl}/AmbassadorsProfile/DeleteAmbassadorWorkExperience/${id}`);
  }

  GetAmbassadorWorkExperience(params: any) {
    return this.http.get(`${environment.apiUrl}/AmbassadorsProfile/GetAmbassadorWorkExperience`, { params });
  }

  // --- Volunteering Experience ---
  AddOrUpdateAmbassadorVolunteeringExperience(data: any) {
    return this.http.post(`${environment.apiUrl}/AmbassadorsProfile/AddOrUpdateAmbassadorVolunteeringExperience`, data);
  }

  DeleteAmbassadorVolunteeringExperience(id: any) {
    return this.http.delete(`${environment.apiUrl}/AmbassadorsProfile/DeleteAmbassadorVolunteeringExperience/${id}`);
  }

  GetAmbassadorVolunteeringExperience(params: any) {
    return this.http.get(`${environment.apiUrl}/AmbassadorsProfile/GetAmbassadorVolunteeringExperience`, { params });
  }

  // --- CV Operations ---
  UploadAmbassadorCv(data: any) {
    return this.http.post(`${environment.apiUrl}/AmbassadorsProfile/UploadAmbassadorCv`, data);
  }

  GetAmbassadorCvData(params: any) {
    return this.http.get(`${environment.apiUrl}/AmbassadorsProfile/GetAmbassadorCvData`, { params });
  }
}
